import React, { useEffect, useMemo, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useSelector } from 'react-redux'

import {
  Collapse,
  Image,
  Input,
  Space
} from '@lockerpm/design';

import {
  CopyOutlined
} from "@ant-design/icons";

import ReferralIcon from '../../../../assets/images/icons/referral.svg'

import itemsComponents from "../../../../components/items";

import referralServices from "../../../../services/referral";
import global from "../../../../config/global";
import common from "../../../../utils/common";

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  TelegramIcon,
  TelegramShareButton
} from "react-share";

const Referral = (props) => {
  const { RouterLink } = itemsComponents;
  const { t } = useTranslation();

  const { className } = props;

  const plan = useSelector((state) => state.payment.plan);
  const locale = useSelector((state) => state.system.locale);

  const [collapseKeys, setCollapseKeys] = useState([])
  const [referrals, setReferrals] = useState({
    referral_link: ''
  })

  const planText = useMemo(() => {
    if (['pm_free', 'pm_premium'].includes(plan?.alias)) {
      return t('plans.premium')
    }
    return t('plans.family')
  }, [plan, locale])

  useEffect(() => {
    getReferrals();
  }, [])

  const getReferrals = () => {
    referralServices.get_referrals().then((res) => {
      setReferrals(res)
    }).catch(() => {
      setReferrals({
        referral_link: ''
      })
    })
  }

  const CollapseHeader = () => {
    return <div className="w-full">
      <div
        className="flex items-center justify-between"
        style={{width: 'calc(100% - 24px)'}}
      >
        <div className="flex items-center">
          <div>
            <div className="text-xl font-semibold">
              {t('rewards.referral.title') }
            </div>
            {
              collapseKeys.length === 0 && <span
                className="text-black-500 lg:hidden md:flex"
              >
                {t('rewards.note1', { month: 1, plan: planText })}
              </span>
            }
          </div>
          {
            collapseKeys.length === 0 && <span
              className="ml-4 text-black-500 lg:flex md:hidden hidden"
            >
              {t('rewards.note1', { month: 1, plan: planText })}
            </span>
          }
        </div>
        <div className="flex items-center">
          <div className="mr-3 font-semibold">
            {referrals.referred}/{referrals.referral_limit}
          </div>
          <Image
            src={ReferralIcon}
            preview={false}
          />
        </div>
      </div>
      {
        plan?.alias !== 'pm_free' &&
        plan?.extra_time > 0 &&
        referrals.referred > 0 && <div
          className="flex items-center"
        >
          <RouterLink
            label={t('rewards.discontinue')}
            flex={''}
            routerName={global.keys.SETTINGS_PLANS_BILLING}
          />
          <span className="ml-1">{t('rewards.discontinue_note')}</span>
        </div>
      }
    </div>
  }

  const CollapseBody = () => {
    return <div>
      <div className="lg:w-full md:w-full mb-4">
        {t('rewards.referral.subtitle')}
      </div>
      <div className="text-head-6 font-semibold">
        {t('rewards.referral.subtitle1')}
      </div>
      <div className="mb-4 text-black-500">
        {t('rewards.referral.subtitle1_desc')}
      </div>
      <div className="flex items-center justify-between w-full">
        <div style={{
          width: `calc(100% - 160px)`
        }}>
          <Input
            value={referrals.referral_link}
            readOnly
            suffix={<CopyOutlined
              className="cursor-pointer"
              onClick={() => common.copyToClipboard(referrals.referral_link)}
            />}
          />
        </div>
        <Space size={[12, 12]}>
          <FacebookShareButton
            url={referrals.referral_link}
            quote={t('rewards.referral.network_title')}
          >
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton>
          <TwitterShareButton
            url={referrals.referral_link}
            quote={t('rewards.referral.network_title')}
          >
            <TwitterIcon size={32} round={true} />
          </TwitterShareButton>
          <TelegramShareButton
            url={referrals.referral_link}
            quote={t('rewards.referral.network_title')}
          >
            <TelegramIcon size={32} round={true} />
          </TelegramShareButton>
        </Space>
      </div>
    </div>
  }

  return (
    <div className={`referral ${className}`}>
      <Collapse
        activeKey={collapseKeys}
        expandIconPosition={'end'}
        onChange={setCollapseKeys}
      >
        <Collapse.Panel
          key="1"
          header={<CollapseHeader/>}
        >
          <CollapseBody />
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

export default Referral;